import React from "react";
import styled from "styled-components";

const Content = styled.div`
  margin: 12px 12px;
`;

export default Content;
